import styled from 'styled-components';

export const DicomViewerIFrame = styled.iframe<{ isSharing?: boolean }>`
  width: 100%;
  height: calc(100vh - 99px);
  border: none;
  position: absolute;
  top: ${(props) => (props.isSharing ? 60 : 46)}px;
  left: 0;
  right: 0;
  bottom: 0;

  ${(props) => props.theme.breakpoints.down('sm')} {
    height: calc(100vh - 114px);
  }
`;

export const DicomViewerHeader = styled.div`
  height: 33px;
  background-color: #27272b;
  padding-top: 13px;
  padding-left: 10px;
`;

export const DicomViewerTitle = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  ${(props) => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`;
